import { useParams } from 'react-router-dom'

import ThresholdsContainer from '../Thresholds/Container'

import ZoneUtils from '@/Util/ZoneUtils'

export default function ZoneThresholds({ selectedZone }) {
  const params = useParams()
  const basePath = ZoneUtils.getZoneBasePath(params)
  return <ThresholdsContainer basePath={basePath} selectedZone={selectedZone} />
}
